import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
	import { debounce } from '@cnamts/vue-dot/src/functions/debounce';

	import { CityService } from '@/services/city-service';
	import { formatCityDisplayedName } from '../utils/postal-codes-utils';
	import { StructureApiService } from '@/services/structure-api-service';
	import { GeoApiCity } from '@/types/geo-api-city';
	import { Structure } from '@/types/structure';
	import { selectedStructureId } from '../store/store';
	import { TraceEventService } from '@/services/trace-event-service';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'search-section',
  emits: ["on-change-structures-list", "on-change-city"],
  setup(__props, { emit: emits }: { emit: ({
		(e: 'on-change-structures-list', structureList: Structure[]): void;
		(e: 'on-change-city', city: GeoApiCity): void;
	}), expose: any, slots: any, attrs: any }) {

	const disabledPeopleFilter = ref(false);
	const chairMountedMammographFilter = ref(false);

	const search = ref('');
	const selectedCity = ref('');
	const loadingInput = ref(false);
	const cities = ref<GeoApiCity[]>([]);
	const citiesDisplayNames = computed(() => cities.value.map(c => formatCityDisplayedName(c.nom, c.codesPostaux, c.departement.nom)));

	const loadingSearch = ref(false);

	const SEARCH_DELAY_MILLISECONDS = 500;
	const SEARCH_MIN_CHARACTERS_TRIGGER = 2;

	

	/**
	 * Trigger la recherche des villes dès que l'utilisateur saisi plus de 2 caractères
	 */
	watch(
		search,
		debounce(async() => {
			if (!citiesDisplayNames.value.includes(search.value) && search.value?.length > SEARCH_MIN_CHARACTERS_TRIGGER) {
				try {
					loadingInput.value = true;

					cities.value = await CityService.getCityList(search.value);
				} finally {
					loadingInput.value = false;
				}
			}
		}, SEARCH_DELAY_MILLISECONDS)
	);

	/**
	 * Lance la recherche des structures en appelant l'API
	 */
	function searchStructures(): void {
		const city = cities.value.find(c => formatCityDisplayedName(c.nom, c.codesPostaux, c.departement.nom) === selectedCity.value);
		if (city) {
			emits('on-change-city', city);
			loadingSearch.value = true;

			// On trace la recherche des structures
			TraceEventService.trace('RECHERCHE');

			StructureApiService.getStructuresListByCoordinatesAndFeatures(
				city.centre.coordinates[0],
				city.centre.coordinates[1],
				disabledPeopleFilter.value,
				chairMountedMammographFilter.value
			)
				.then((structuresList) => {
					emits('on-change-structures-list', structuresList);
					selectedStructureId.value = null;
				})
				.finally(() => {
					loadingSearch.value = false;
				});
		}
	}


return { __sfc: true,disabledPeopleFilter, chairMountedMammographFilter, search, selectedCity, loadingInput, cities, citiesDisplayNames, loadingSearch, SEARCH_DELAY_MILLISECONDS, SEARCH_MIN_CHARACTERS_TRIGGER, emits, searchStructures }
}

})